import { FormGroup } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';
import type { GeneralSettings } from '../../../../../shared/settings/general';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';
import Text from '../../../generic/Text';

type Props = {
  settings: GeneralSettings;
  onUpdateSettings: (settings: Partial<GeneralSettings>) => void;
  isDisabled: boolean;
};

/**
 * Displays the components section of the general settings page.
 */
const ComponentsSection: VoidFunctionComponent<Props> = ({ settings, isDisabled, onUpdateSettings }) => {
  return (
    <>
      <Text.H3>Packages</Text.H3>
      <div>
        <FormGroup>
          <LabeledTextInput
            label="Internal Package Signatures"
            value={settings.dependencySignatures || ''}
            placeholder="Separate multiple signatures with commas"
            onChange={(dependencySignatures) => {
              onUpdateSettings({
                dependencySignatures,
              });
            }}
            isDisabled={isDisabled}
          />
        </FormGroup>
        {settings.dependencySignatures ? (
          <p>
            <span>FOSSA will ignore dependencies that match:</span>
            {settings.dependencySignatures.split(',').map((dependencySignature) => (
              <code className="margin-right-sm">{dependencySignature.trim()}</code>
            ))}
          </p>
        ) : (
          <p>
            Use this field to specify signatures for marking internal package naming conventions. FOSSA will recognize
            any package that contains these signatures in their names as internal dependencies and will ignore these
            dependencies.
          </p>
        )}
      </div>
    </>
  );
};

export default ComponentsSection;
